var React = require('react');

function CircleV (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9.5","cy":"9","r":"8.5","stroke":"#585C62","key":0}),React.createElement("g",{"clipPath":"url(#clip0_15293_7320)","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.9592 6.54036C13.2131 6.7942 13.2131 7.20575 12.9592 7.45959L8.95923 11.4596C8.70539 11.7134 8.29383 11.7134 8.03999 11.4596L6.03999 9.45959C5.78615 9.20575 5.78615 8.7942 6.03999 8.54036C6.29383 8.28652 6.70539 8.28652 6.95923 8.54036L8.49961 10.0807L12.04 6.54036C12.2938 6.28652 12.7054 6.28652 12.9592 6.54036Z","fill":"#585C62"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_15293_7320"},React.createElement("rect",{"x":"5.5","y":"5","width":"8","height":"8","rx":"2","fill":"white"})))]);
}

CircleV.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = CircleV;

CircleV.default = CircleV;
